import { render } from "./UsersTab.vue?vue&type=template&id=70b35612"
import script from "./UsersTab.vue?vue&type=script&lang=js"
export * from "./UsersTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__